import { Cookie, Header } from "~/types";
import {
  defaultHeaders,
  SendOTPResult,
  sendOTPViaSMS,
  setAuth,
  setDefaultHeaders,
  submitOTP,
  SubmitOTPResult,
} from "../auth";
import { setCookie } from "~/utils/client_cookie";
import { config } from "../config";
import { loadRecaptcha } from "~/utils/recaptcha";
import { HubbleOTPAuth } from "~/screens/hubble_otp_auth/hubble_otp_auth";
import { openModalV2 } from "~/shared_states/modal";

export function logIntoHubble(afterLogin: () => void) {
  void loadRecaptcha();
  const onPhoneSubmit = async (phoneNumber: string): Promise<SendOTPResult> => {
    return sendOTPViaSMS(phoneNumber);
  };

  const onOtpSubmit = async (
    phoneNumber: string,
    otp: string,
    otpToken: string
  ): Promise<SubmitOTPResult> => {
    return submitOTP(phoneNumber, otp, otpToken, false);
  };

  const onResendOtp = async (phoneNumber: string): Promise<SendOTPResult> => {
    return sendOTPViaSMS(phoneNumber);
  };

  const onOtpSuccess = async (
    phoneNumber: string,
    submitResult: SubmitOTPResult
  ): Promise<void> => {
    if (
      window.location.pathname == "/auth" ||
      window.location.pathname == "/login"
    ) {
      window.parent.postMessage(
        {
          type: "login",
          payload: {
            success: true,
            sid: submitResult.sessionId,
          },
        },
        "*"
      );
    }

    setDefaultHeaders({
      ...defaultHeaders(),
      [Header.SessionId]: submitResult.sessionId,
    });

    setAuth(() => {
      return { sessionId: submitResult.sessionId } as any;
    });

    setCookie({
      key: Cookie.SessionId,
      value: submitResult.sessionId,
      expiryInMinutes: config.sesssionDurationInMinutes.webstore,
    });

    afterLogin();
  };

  openModalV2(() => (
    <HubbleOTPAuth
      onPhoneSubmit={onPhoneSubmit}
      onOtpSubmit={onOtpSubmit}
      onResendOtp={onResendOtp}
      onOtpSuccess={onOtpSuccess}
      mode="hubble"
    />
  ));
}
